import { motion } from 'framer-motion'
import styled from 'styled-components'
import { mobileL } from '../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const OnboardingPageWrapper = styled(motion.div)`
  background-color: #fafafa !important;
  width: 90%;
  margin: auto;

  ${mobileL({
    paddingBot: '10px !important',
    width: '100%',
  })};

  .container-step {
    width: 100%;
    flex-direction: column;
    position: relative;
    gap: 3em;
  }

  .letsGO {
    ${mobileL({
      margin: '-6em auto 0px auto !important',
    })};
  }

  .main-container {
    height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow-y: scroll;

    align-items: center;
    background-color: #fafafa;
    ${mobileL({
      overflowY: 'unset',
    })};
  }

  .contract-fields {
    span {
      text-transform: capitalize !important;
    }
  }
  h2 {
    font-size: 28px;
    width: 100%;
    color: #659dff;
    margin-bottom: 1.5rem;
    font-weight: 600;
  }

  .grey-btn {
    height: 50px;
  }
  .link-element {
    color: #1890ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .page-indicator {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 1em;
    font-size: 1.4em;
    font-weight: 600;
  }

  .container-skills {
    .ant-radio-group {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

    .ant-radio-button-wrapper {
      flex-grow: 1;
      display: grid;
      place-items: center;
      margin: 0 !important;
      padding: 8px 10px !important;
    }
  }

  .wrap-and-gap {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .skip-link {
    position: absolute;
    right: 20px;
    top: 40px;
    border: none;
    span {
      text-decoration: underline;
      font-size: 1.3em;
    }
  }

  .skip-link:focus {
    color: black;
  }

  // create media queries for movile device
  @media (max-width: 768px) {
    .container-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 5rem;
    }
  }
`
